import React from 'react';
import Helmet from 'react-helmet';

import cockpit from '../helpers/cockpit.js';

import './agb.module.css';

function AGBPage({ data }) {

  return (
    <div styleName="AGB">
      <Helmet
        title={data.content.agb_title}
      />

      <h1>{data.content.impressum_title}</h1>
      <div styleName="content" dangerouslySetInnerHTML={{__html: data.content.impressum_text}}></div>
      <h1>{data.content.datenschutz_title}</h1>
      <div styleName="content" dangerouslySetInnerHTML={{__html: data.content.datenschutz_text}}></div>
      <h1>{data.content.agb_title}</h1>
      <div styleName="content" dangerouslySetInnerHTML={{__html: data.content.agb_text}}></div>
    </div>
  );
}

export default cockpit(AGBPage);

export const agbPageQuery = graphql`

  query agbPageQuery {
    content: regionAgb {
      agb_title
      agb_text
      datenschutz_title
      datenschutz_text
      impressum_title
      impressum_text
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/agb.js